<template>
  <form class="vue-vat-form vue-js-taxes-toggle" @change="taxToggle">
    <h3>{{ translations.prices_on_the_website }}</h3>
    <div class="switch switch--horizontal">
      <input
        name="tax_display_status"
        value="taxes_included"
        id="tax-toggle-one"
        type="radio"
        :checked="selectedValue"
        @change="setActive('taxes_included')"
      />
      <label
        for="tax-toggle-one"
        class="switch__label"
        :class="{ active: selectedValue }"
      >
        {{ translations.included_vat }}
      </label>

      <input
        name="tax_display_status"
        value="taxes_excluded"
        id="tax-toggle-two"
        type="radio"
        :checked="!selectedValue"
        @change="setActive('taxes_excluded')"
      />
      <label
        for="tax-toggle-two"
        class="switch__label"
        :class="{ active: !selectedValue }"
      >
        {{ translations.excluded_vat }}
      </label>
    </div>
  </form>
</template>

<script>
export default {
  name: 'TaxToggleWells',
  data() {
    return {
      translations: {
        prices_on_the_website: ws_vue_store.translations.prices_on_the_website,
        included_vat: ws_vue_store.translations.included_vat,
        excluded_vat: ws_vue_store.translations.excluded_vat,
      }
    };
  },
  computed: {
    selectedValue() {
      return this.$store.getters.getTaxesEnabled;
    }
  },
  methods: {
    setActive(value) {
      // document.cookie = `ws_taxes_display_selection=${value}; path=/`;
      this.taxToggle();
    }
  },
  props: {
    taxToggle: {
      type: Function,
      default: () => {}
    }
  }
};
</script>
